import { classNames } from "@/utils/classNames";
import { IconName } from "./iconMapping";
import { Icon } from "./Icon";
import { TMessage, TMessageParam } from "@/i18n/tt";
import { when } from "@/utils/functions";

import { useTranslation } from "@/stores/RootStoreContext";
import { MouseEvent } from "react";

export type TagColor = "success" | "error" | "warning" | "neutral" | "info";

export type TagProps = {
  label: string | TMessage | TMessageParam;
  color: TagColor;
  tooltip?: string | TMessage;
  icon?: IconName;
  compact?: boolean;
  isButton?: boolean;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  className?: string;
};

export const Tag = ({
  label,
  color = "neutral",
  tooltip,
  icon,
  compact,
  isButton = false,
  onClick,
  className,
}: TagProps) => {
  const { t } = useTranslation();
  return (
    <div
      data-tooltip={typeof tooltip === "string" ? tooltip : when(tooltip, t)}
      className={classNames(
        className,
        "inline-flex",
        "flex-none",
        "items-center",
        "gap-1",
        isButton || onClick ? "cursor-pointer" : "cursor-default",
        "w-fit",
        "max-w-full",
        "text-xs",
        "py-1",
        "rounded-sm",
        compact ? "px-1" : "px-3",
        color === "info"
          ? "bg-info color-info"
          : color === "error"
            ? "bg-error color-error"
            : color === "warning"
              ? "bg-warning color-warning"
              : color === "success"
                ? "bg-success color-success"
                : "bg-gray-soft subtle",
        onClick && "hover:underline",
      )}
      onClick={onClick}
    >
      {icon && <Icon name={icon} size={"sm"} />}
      <span className={"overflow-hidden text-ellipsis whitespace-nowrap"}>
        {typeof label === "string" ? label : t(label)}
      </span>
    </div>
  );
};
